import UDPage from './UniversalDetails';

export default UDPage;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/index.jsx